import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { useEffect } from 'react';
import { Option } from 'fp-ts/Option';
import { createZodFormResolver, useFormControls, UseFormControlsParams } from '@mews/framework';
import { BillType } from '@mews-commander/data-access';
import { useGetCreditNoteCounters, useIsCreditNoteCountersEnabled } from '../../../counters/utils';
import { findCounterByBillType } from '../../../counters/helpers';
import { createValidationSchema, FormValues } from './schema';

type UseReinstateFormControlsParams = Pick<UseFormControlsParams<FormValues>, 'onSubmit'> & {
    billType: Option<BillType>;
};

export const useReinstateFormControls = ({ onSubmit, billType }: UseReinstateFormControlsParams) => {
    const creditNoteCountersEnabled = useIsCreditNoteCountersEnabled();
    const counters = useGetCreditNoteCounters();

    const creditNoteCounterId = pipe(
        counters,
        array.filter((counter) => counter.isDefault),
        array.findFirst(findCounterByBillType(billType)),
        option.foldW(
            () => undefined,
            (it) => it.id
        )
    );
    const resolver = createZodFormResolver(createValidationSchema(creditNoteCountersEnabled));

    const formControls = useFormControls<FormValues>({
        onSubmit,
        resolver,
        defaultValues: {
            reason: '',
            creditNoteCounterId: '',
        },
    });

    const { reset } = formControls;

    useEffect(() => {
        reset({
            creditNoteCounterId,
        });
    }, [reset, creditNoteCounterId]);

    return formControls;
};
